export default "skymp5-front/b504fd8bc5ee0f86635573d4a74b9778.svg";